import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Button } from 'react-bootstrap';
import * as jwtDecode from 'jwt-decode';
import { signin } from './cognito-auth';
import { doLogin, saveLoginData, doLoginFail, forwardForgotPwd } from '../../actions/login/index';
import { commonRenderInput } from '../../components/common/access-form';
import { verifyForm, verifyAccount } from '../../components/common/access-form-validation';


class LoginForm extends Component {

    loginSubmit = (values) => {
        const { doLogin, saveLoginData, doLoginFail } = this.props;
        let email = values.inputLoginEmail;
        let password = values.inputLoginPwd;
        if (email && password) {
            doLogin();
        }

        let doLoginPromise = new Promise((resolve, reject) => {
            let signinSuccess = (data) => {
                resolve(data);
            };
            let signinError = (err) => {
                reject(err);
            };
            // call cognito api
            signin(email, password,signinSuccess,signinError);
        });

        doLoginPromise
        .then((data) => {
            const idToken = data.idToken.jwtToken;
            let account = jwtDecode(idToken);

            // save data to state
            saveLoginData(idToken, data.accessToken.jwtToken, account);
        })
        .catch((err) => {
            // do login fail
            doLoginFail(err.message);
        });
    }

    render() {
        const { handleSubmit, verifyFormPass, forwardForgotPwd } = this.props;

        return (
            <div className='area-login-form form-custom'>
                <form onSubmit={handleSubmit(this.loginSubmit)}>
                    <Field name="inputLoginEmail" type="email" component={commonRenderInput} validate={verifyAccount} label="Account" placeholder="Please input account" />
                    <Field name="inputLoginPwd" type="password" component={commonRenderInput} label="Password" placeholder="Please input password"/>
                    <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                        Sign in
                    </Button>

                    <div className="area-forgot-pwd" >
                        <span className='custom-link' onClick={forwardForgotPwd}>
                            Forgot your password?
                        </span>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let verifyFormPass = verifyForm(state.form['LoginForm']);

    return {
        verifyFormPass : verifyFormPass
    }
};

LoginForm = reduxForm({
    form: 'LoginForm',  // a unique identifier for this form
})(LoginForm);

export default connect(
    mapStateToProps,
    { doLogin, saveLoginData, doLoginFail, forwardForgotPwd }
)(LoginForm);